import { Field, useField } from 'vee-validate';
import { ref } from 'vue';


export default {
  __name: 'RatingField',
  setup(__props, { expose }) {
  expose();

const { errorMessage, setValue } = useField('rating');

const rating = ref(0);
const hoverRating = ref(0);
const stars = ref([1, 2, 3, 4, 5]);

const setRating = (star) => {
    rating.value = star;
    setValue(star);
};

const setHover = (star) => {
    hoverRating.value = star;
};

const clearHover = (star) => {
    hoverRating.value = star;
};

const __returned__ = { errorMessage, setValue, rating, hoverRating, stars, setRating, setHover, clearHover, get Field() { return Field }, get useField() { return useField }, ref }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}